module.exports = __webpack_public_path__ + "img/moco.46de94ec.jpg";